import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { SEO } from "@/components/SEO";
import { CheckoutDialog } from "@/components/CheckoutDialog";
import { SERVICES } from "@/data/services";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { HeroSection } from "@/components/home/HeroSection";
import { ServicesSection } from "@/components/home/ServicesSection";
import { MissionSection } from "@/components/home/MissionSection";
import { PricingSection } from "@/components/home/PricingSection";
import { TestimonialsSection } from "@/components/home/TestimonialsSection";
import { ContactSection } from "@/components/home/ContactSection";

export default function Home() {
  const navigate = useNavigate();
  const [checkoutOpen, setCheckoutOpen] = useState(false);
  const [checkoutType, setCheckoutType] = useState("order");
  const [checkoutItem, setCheckoutItem] = useState(null);
  const [pickerOpen, setPickerOpen] = useState(false);

  const orderTimer = useRef(null);
  useEffect(() => () => { if (orderTimer.current) clearTimeout(orderTimer.current); }, []);

  const orderService = (service) => {
    setCheckoutType("order");
    setCheckoutItem(service);
    setPickerOpen(false);
    // Stagger opening the checkout until the picker dialog has fully closed,
    // so two Radix dialogs never transition at once (mobile focus/scroll-lock crash).
    if (orderTimer.current) clearTimeout(orderTimer.current);
    orderTimer.current = setTimeout(() => setCheckoutOpen(true), 260);
  };

  return (
    <div className="bg-brand-grey min-h-screen">
      <SEO
        title="Tanz-Bridge International LTD | Commitment for Excellence"
        description="Tanz-Bridge International LTD — technical consultancy linking producers to the global market. Research, IT, Trading, Consulting, Marketing & Environmental services in Tanzania."
        path="/"
      />
      <Navbar onOrder={() => setPickerOpen(true)} />
      <HeroSection onOrder={() => setPickerOpen(true)} />
      <ServicesSection />
      <MissionSection />
      <PricingSection />
      <TestimonialsSection />
      <ContactSection />
      <Footer />

      {/* Service picker dialog */}
      <Dialog open={pickerOpen} onOpenChange={setPickerOpen}>
        <DialogContent data-testid="service-picker-dialog" className="bg-brand-card border border-gray-200 text-brand-dark max-w-lg">
          <DialogTitle className="sr-only">Choose a service to order</DialogTitle>
          <h3 className="text-2xl font-heading mb-1 text-brand-dark">Choose a service to order</h3>
          <p className="text-sm text-gray-500 mb-4">Pay securely with M-Pesa after selecting.</p>
          <div className="grid gap-3 max-h-[60vh] overflow-y-auto pr-1">
            {SERVICES.map((s) => {
              const Icon = s.icon;
              return (
                <button key={s.id} data-testid={`picker-service-${s.id}`} onClick={() => orderService(s)}
                  className="flex items-center gap-4 rounded-sm bg-brand-grey border border-gray-200 hover:border-brand-blue p-4 text-left transition-colors">
                  <div className="h-10 w-10 rounded-sm bg-brand-blue/10 flex items-center justify-center shrink-0">
                    <Icon size={18} className="text-brand-blue" />
                  </div>
                  <div className="flex-1">
                    <p className="font-medium text-brand-dark">{s.name}</p>
                    <p className="text-xs text-gray-500">{s.tagline}</p>
                  </div>
                </button>
              );
            })}
          </div>
        </DialogContent>
      </Dialog>

      <CheckoutDialog open={checkoutOpen} onOpenChange={setCheckoutOpen} type={checkoutType} item={checkoutItem} />
    </div>
  );
}
